import { atom } from 'jotai';
import { CJEvent } from '@teetsh/app/src/types/event';

export const editorCJSeancePayloadAtom = atom<
  | {
      seance: CJEvent;
      classroomId?: string;
      atelierId?: string;
    }
  | undefined
>(undefined);
